import InputText from "../ReusableComponents/InputText";
import React, { useEffect, useState } from "react";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import TextArea from "../ReusableComponents/TextArea";
import { mainTable } from "../css/Common";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import Loader from "../ReusableComponents/Loader";
import MainPopup from "../popup-containers/MainPopup";
import { CityHeader } from "../components/HeaderAttribute";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import CityPopup from "../popup-containers/CityPopup";
import toast from "react-hot-toast";
import { BindAPI, IUDAPI } from "../services/APIConnection";

const City = () => {
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(true);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [popUpData, setPopUpData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [errors, setErrors] = useState({});
  const [rowIndex, setRowIndex] = useState(-1);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  // const [formFields, setFormFields] = useState({ mstCityId: 0, mstCountryId: "", mstStateId: "", });
  const [MstCityId, setMstCityId] = useState(0);
  const [MstCountryId, setMstCountryId] = useState(0);
  const [MstStateId, setMstStateId] = useState(0);
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);

  const [bindCity, setbindCity] = useState([]);

  useEffect(() => {
    BindCityData();
    BindCountryData();
    BindStateData();
  }, []);

  const BindCountryData = async () => {
    const response = await BindAPI("CountryAPI/BindCountry"); // change API name if needed
    if (response && response.data) {
      const formattedData = response.data.Table.map((item) => ({
        value: item.MstCountryId,
        label: item.CountryName,
      }));
      setCountryOptions(formattedData);
      const indiaOption = formattedData.find((item) => item.value === 1);
      if (indiaOption) {
        setFormFields((prev) => ({
          ...prev,
          country: indiaOption,
          state: null, // reset state
        }));

        setErrors((prev) => ({
          ...prev,
          country: "",
          state: "",
        }));
      }
    }
  };

  const BindStateData = async () => {
    const response = await BindAPI("StateAPI/BindState"); // change API name if needed
    if (response && response.data) {
      const formattedData = response.data.Table.map((item) => ({
        value: item.MstStateId,
        label: item.State,
      }));
      setStateOptions(formattedData);
    }
  };

  const BindCityData = async () => {
    setIsLoading(true);
    const response = await BindAPI("CityAPI/BindCity");
    console.log("API Response:", response);
    if (response && response.data) {
      setbindCity(response.data.Table);
    } else {
      setbindCity([]);
    }
    setIsLoading(false);
  };

  var createdBy = sessionStorage.getItem("createdBy");

  const handleSubmit = async (items, flag) => {
    const isValid = validateForm();

    if (flag === 1 || flag === 2) {
      if (!isValid) {
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        return;
      }

      setSubmitBtnDisabled(true);
      setIsLoading(true);

      setIsOpen(false);
      setIsLoading(true);

      const data = {
        mstCityId: MstCityId || 0,
        mstCountryId: formFields.country?.value ? formFields.country.value : 0,
        mstStateId: formFields.state?.value ? formFields.state.value : 0,
        city: formFields.city?.trim() || "",
        cityCode: formFields.cityCode?.trim() || "",
        createdBy: createdBy,
        flag: flag,
      };

      console.log("Sending data to IUDAPI:", data);

      try {
        console.log("Submitted Data: ", data);

        const response = await IUDAPI(data, "CityAPI/IUDCity");
        console.log("IUDAPI response", response);

        if (flag === 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("City Data Inserted Successfully", {
              duration: 3000,
              position: "top-center",
            });
          } else {
            toast.error("City Data Insert Failed", {
              duration: 3000,
              position: "top-center",
            });
          }
        } else if (flag === 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("City Data Modified Successfully", {
              duration: 3000,
              position: "top-center",
            });
          } else {
            toast.error("City Data Modification Failed", {
              duration: 3000,
              position: "top-center",
            });
          }
        }

        setTimeout(cancel, 3000);
      } catch (error) {
        console.error("API error during insert/update:", error);
        toast.error("Something went wrong while adding City  data", {
          duration: 3000,
          position: "top-center",
        });
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
    } else {
      setSubmitBtnDisabled(true);   
      setIsLoading(true);
    
      const data = {
        mstCityId: bindCity[items].MstCityId,
        createdby: parseInt(createdBy, 10),
        flag: flag,
      };

      try {
        const response = await IUDAPI(data, "CityAPI/IUDCity");
        console.log("IUDAPI response", response);

        if (flag === 3) {
          if (response.data.Table[0].Result === "D") {
            toast.success("City Data Deleted Successfully", {
              duration: 3000,
              position: "top-center",
            });
          } else {
            toast.error("Failed to Delete City Data", {
              duration: 3000,
              position: "top-center",
            });
          }
        } else if (flag === 4) {
          if (response.data.Table[0].Result === "B") {
            toast.success("City Data Inactivated Successfully", {
              duration: 3000,
              position: "top-center",
            });
          } else {
            toast.error("City Data Inactivation Failed", {
              duration: 3000,
              position: "top-center",
            });
          }
        } else if (flag === 5) {
          if (response.data.Table[0].Result === "UB") {
            toast.success("City Data Activated Successfully", {
              duration: 3000,
              position: "top-center",
            });
          } else {
            toast.error("City Data Activation Failed", {
              duration: 3000,
              position: "top-center",
            });
          }
        }

        setTimeout(cancel, 3000);
      } catch (error) {
        console.error("API error during delete/activate/inactivate:", error);
        toast.error("Something went wrong. Please try again.", {
          duration: 3000,
          position: "top-center",
        });
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
    }

    console.log("Submit City Data:", formFields);
  };
  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    setIsLoading(false);
    BindCityData();
    setFormFields({
      mstCityId: 0,
      mstCountryId: "",
      mstStateId: "",
      country: "",
      state: "",
      city: "",
      cityCode: "",
    });
    setFormFieldsError({
      countryError: "",
      stateError: "",
      cityError: "",
      cityCodeError: "",
    });
    setErrors({});
  };

  const [formFieldsError, setFormFieldsError] = useState({
    countryError: "",
    stateError: "",
    cityError: "",
    cityCodeError: "",
  });
  const [formFields, setFormFields] = useState({
    mstCityId: 0,
    mstCountryId: "",
    mstStateId: "",
    country: null, // instead of ""
    state: null,
    city: "",
    cityCode: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));

    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };
  const handleCity = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);
    setPopUpData(bindCity[rowIndex]);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);

      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);

      setUnBlockDetails(true);
    }

    const rowData = bindCity[rowIndex];
    setMstCityId(bindCity[rowIndex].MstCityId);

    setPopUpData(rowData);
  };

  const handleEdit = (rowIndex) => {
    setRowIndex(rowIndex);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    const selectedRow = bindCity[rowIndex];

    setFormFields({
      ...formFields,
      country: {
        value: selectedRow.MstCountryId,
        label: selectedRow.CountryName || selectedRow.Country || "", // adjust based on actual API response
      },
      state: {
        value: selectedRow.MstStateId,
        label: selectedRow.State || "", // adjust if StateName used
      },
      city: selectedRow.City,
      cityCode: selectedRow.CityCode,
    });

    setMstCityId(selectedRow.MstCityId);
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(false);
    setAddScreenTitle(true);
    setErrors({});
  };

  const validateForm = () => {
    let errorsObj = {};

    const city = formFields.city?.trim() || "";
    const cityCode = formFields.cityCode?.trim() || "";
    const countryId = formFields.country?.value;
    const stateId = formFields.state?.value;

    // Validate country and state first
    if (!countryId) errorsObj.country = "Select Country";
    if (!stateId) errorsObj.state = "Select State";

    // City validation
    if (!city) {
      errorsObj.city = "Enter City";
    } else if (!/^[A-Za-z ]+$/.test(city)) {
      errorsObj.city = "Only alphabets and spaces are allowed";
    } else {
      const duplicateCity = bindCity.find(
        (x, index) =>
          x.City.toLowerCase() === city.toLowerCase() &&
          x.MstStateId === stateId &&
          x.MstCountryId === countryId &&
          index !== rowIndex
      );
      if (duplicateCity) {
        errorsObj.city =
          "City already exists in the selected state and country";
      }
    }

    // CityCode validation
    if (!cityCode) {
      errorsObj.cityCode = "Enter City Code";
    } else if (!/^[A-Z]{1,3}$/.test(cityCode)) {
      errorsObj.cityCode = "Enter 1–3 uppercase letters";
    } else {
      const duplicateCode = bindCity.find(
        (x, index) =>
          x.CityCode.toLowerCase() === cityCode.toLowerCase() &&
          x.MstStateId === stateId &&
          x.MstCountryId === countryId &&
          index !== rowIndex
      );
      if (duplicateCode) {
        errorsObj.cityCode =
          "City Code already exists in the selected state and country";
      }
    }

    setErrors(errorsObj);
    return Object.keys(errorsObj).length === 0;
  };

  const validateField = (
    name,
    value,
    newCountry = formFields.country,
    newState = formFields.state
  ) => {
    const countryId = newCountry?.value;
    const stateId = newState?.value;

    if (name === "city") {
      const city = value.trim();
      if (!city) {
        setErrors((prev) => ({ ...prev, city: "Enter City" }));
      } else if (!/^[A-Za-z ]+$/.test(city)) {
        setErrors((prev) => ({
          ...prev,
          city: "Only alphabets and spaces are allowed",
        }));
      } else {
        const duplicateCity = bindCity.find(
          (x, index) =>
            x.City.toLowerCase() === city.toLowerCase() &&
            x.MstStateId === stateId &&
            x.MstCountryId === countryId &&
            index !== rowIndex
        );
        setErrors((prev) => ({
          ...prev,
          city: duplicateCity
            ? "City already exists in the selected state and country"
            : "",
        }));
      }
    }

    if (name === "cityCode") {
      const cityCode = value.trim();
      if (!cityCode) {
        setErrors((prev) => ({ ...prev, cityCode: "Enter City Code" }));
      } else if (!/^[A-Z]{1,3}$/.test(cityCode)) {
        setErrors((prev) => ({
          ...prev,
          cityCode: "Enter 1–3 uppercase letters",
        }));
      } else {
        const duplicateCode = bindCity.find(
          (x, index) =>
            x.CityCode.toLowerCase() === cityCode.toLowerCase() &&
            x.MstStateId === stateId &&
            x.MstCountryId === countryId &&
            index !== rowIndex
        );
        setErrors((prev) => ({
          ...prev,
          cityCode: duplicateCode
            ? "City Code already exists in the selected state and country"
            : "",
        }));
      }
    }

    if (name === "country") {
      setErrors((prev) => ({
        ...prev,
        country: value?.value ? "" : "Select Country",
      }));
    }

    if (name === "state") {
      setErrors((prev) => ({
        ...prev,
        state: value?.value ? "" : "Select State",
      }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    validateField(name, value);
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="City"
          header={CityHeader}
          records={bindCity}
          handleEdit={handleEdit}
          handleAction={handleCity}
          showAdd={showAdd}
          blockView={false}
        />
      )}
      {visibleAdd && (
        <>
          <div className="w-full">
            <div className="flex flex-col w-full">
              <div className={mainTable.clientMasterMainAdd}>
                <AddScreenTitle
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  title="City"
                />
              </div>
            </div>

            <div className="mx-auto md:w-[500px] w-full">
              <div className="relative w-full h-full max-w-xl md:h-auto">
                <div className="relative bg-white rounded-lg shadow">
                  <div className="px-6 py-6 lg:px-8">
                    <form className="space-y-6" action="#">
                      <AutoDropDown
                        name="country"
                        title="Country"
                        options={countryOptions}
                        placeholder="Select Country"
                        Class="custom-class"
                        disabled={false}
                        classStar="text-red-500"
                        errorMessage={errors.country}
                        selectedOption={formFields.country}
                        controlFunc={(selected) => {
                          const updatedCountry = selected;
                          const updatedState = null;

                          setFormFields((prev) => ({
                            ...prev,
                            country: updatedCountry,
                            state: updatedState,
                          }));

                          if (formFields.city?.trim()) {
                            validateField(
                              "city",
                              formFields.city,
                              updatedCountry,
                              updatedState
                            );
                          }
                          if (formFields.cityCode?.trim()) {
                            validateField(
                              "cityCode",
                              formFields.cityCode,
                              updatedCountry,
                              updatedState
                            );
                          }
                        }}
                        controlFuncBlur={() =>
                          validateField("country", formFields.country)
                        }
                        // tabIndex="1"
                      />
                      <AutoDropDown
                        name="state"
                        title="State"
                        options={stateOptions}
                        placeholder="Select State"
                        Class="custom-class"
                        disabled={false}
                        classStar="text-red-500"
                        errorMessage={errors.state}
                        selectedOption={formFields.state}
                        controlFunc={(selected) => {
                          const updatedState = selected;

                          setFormFields((prev) => ({
                            ...prev,
                            state: updatedState,
                          }));

                          if (formFields.city?.trim()) {
                            validateField(
                              "city",
                              formFields.city,
                              formFields.country,
                              updatedState
                            );
                          }
                          if (formFields.cityCode?.trim()) {
                            validateField(
                              "cityCode",
                              formFields.cityCode,
                              formFields.country,
                              updatedState
                            );
                          }
                        }}
                        controlFuncBlur={() =>
                          validateField("state", formFields.state)
                        }
                        // tabIndex="1"
                      />

                      <InputText
                        inputType="text"
                        title="City"
                        name="city"
                        classStar="text-red-500"
                        placeholder="Enter City"
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        content={formFields.city}
                        disabled={false}
                        errorMessage={errors.city}
                        isRequired={true}
                      />
                      <InputText
                        inputType="text"
                        title="City Code"
                        name="cityCode"
                        classStar="text-red-500"
                        placeholder="Enter City Code"
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        content={formFields.cityCode}
                        disabled={false}
                        errorMessage={errors.cityCode}
                        isRequired={true}
                      />

                      <div className="flex justify-center mt-6">
                        <Buttons
                          addScreenTitle={addScreenTitle}
                          updateScreenTitle={updateScreenTitle}
                          disabledBtn={false}
                          viewSaveButton={false}
                          handleSubmit={handleSubmit}
                          cancel={cancel}
                          onClick={() =>
                            handleSubmit(0, addScreenTitle ? 1 : 2)
                          }
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup //Main Pop up
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(false)}
      >
        <div>
          <PopUpScreenTitle //Popup screen Title
            title="City"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <CityPopup
            data={popUpData}
            countryOptions={countryOptions}
            stateOptions={stateOptions}
          />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default City;
